<div class="container">
  <div class="container__content">
    <lib-input
      type="checkbox"
      label="default (all)"
      [value]="check(BOOK_ALIAS_GIFT)"
      (valueChange)="
        $event ? select(BOOK_ALIAS_GIFT) : deselect(BOOK_ALIAS_GIFT)
      "
    ></lib-input>
    <ng-container *ngIf="!isAll">
      <lib-input
        *ngFor="let alias of aliasArr"
        type="checkbox"
        [label]="alias"
        [value]="check(alias)"
        (valueChange)="$event ? select(alias) : deselect(alias)"
      ></lib-input>
    </ng-container>
  </div>
</div>
